import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPagedResponse } from "../components/shared/Tables/PagedTable";
import { PageMode } from "../models/PagedTable";
import { IPart } from "../models/Part";

/**
 * Fetches a single large page of currently-live eBay listings so the
 * Marketplace Insights page can rank them client-side (top viewed in
 * the last 30 days / oldest listings). Keeps the payload shape identical
 * to the main listings table so the same `IPart` fields are available.
 */
export default function useMarketplaceListingsSample(pageSize = 250) {
  const { post } = useApiHelper();
  const staleTime = 1000 * 60 * 5;

  const listings = useQuery({
    queryKey: ["marketplaceInsights", "listingsSample", pageSize],
    queryFn: () =>
      post<{ searchBody: Record<string, unknown> }, IPagedResponse<IPart>>(
        `/part/listings/1?pageMode=${PageMode.Listed}&pageSize=${pageSize}`,
        { searchBody: {} }
      ),
    staleTime,
  });

  return {
    listings,
    parts: listings.data?.data?.rows ?? [],
    total: listings.data?.data?.total ?? 0,
  };
}
